export const REMINDER_MESSAGES = [
  'Outstanding work!\nYou can close the PDF tab now',
  'Great job!\nQuick reminder to close the PDF tab',
  'Well done!\nFeel free to close the PDF tab and move on',
  'Review complete!\nYou can close the document tab now',
  "You're doing great!\nDon't forget to close the PDF tab",
  'Nicely done!\nClose the tab and keep going',
] as const

export type ReminderMessage = (typeof REMINDER_MESSAGES)[number]

export function pickRandom(): ReminderMessage {
  const index = Math.floor(Math.random() * REMINDER_MESSAGES.length)
  return REMINDER_MESSAGES[index]
}
